module.exports = __webpack_public_path__ + "img/DutchPlate_TH.d9deb5ce.png";